<!-- Pulsante per generare analisi AI (solo per decision_table o vecchio comportamento) -->
@if (type !== 'survey') {
  <div class="row justify-content-center mt-5 mb-3">
    @if (!loading) {
      <button
        class="size-small danger text-white"
        matButton="filled"
        (click)="generateAIAnalysis()"
        >{{ 'modal.modal-ai-analysis.title' | translate }}
      </button>
      @if (analysis) {
        <button mat-raised-button color="primary"
          class="action-button ml-2"
          (click)="copyText(analysis)"
          >
          {{ 'generic.copy-text' | translate }}
        </button>
      }
    } @else {
      <mat-spinner diameter="40"></mat-spinner>
    }
  </div>

  @if (analysis) {
    <div class="row ai-text-container">
      <markdown [data]="analysis"></markdown>
    </div>
  }
}

<!-- Nuova UI per analisi AI delle survey -->
@if (type === 'survey') {
  <div class="row justify-content-center mt-5 mb-3">
    <div class="col-12">
      <!-- Processing attachments message -->
      @if (attachmentsProcessing) {
        <div class="alert alert-info d-flex align-items-center mb-3" role="alert">
          <mat-icon class="mr-2">hourglass_empty</mat-icon>
          <div>
            <strong>{{ processingMessage }}</strong>
            <br>
            <small>The AI Analysis button will be enabled once all attachments are processed.</small>
          </div>
        </div>
      }

      <!-- Button to retrieve all attachments (including processing/waiting) -->
      @if (hasAttachments) {
        <div class="text-center mb-3">
          <button
            mat-raised-button
            color="primary"
            (click)="toggleAttachments()"
            [disabled]="loadingAttachments"
            >
            <mat-icon>{{ showAttachments ? 'visibility_off' : 'attachment' }}</mat-icon>
            {{ showAttachments ? ('Hide Attachments' | translate) : ('View Attachments' | translate) }}
            @if (loadingAttachments) {
              <mat-spinner diameter="20" class="ml-2"></mat-spinner>
            }
          </button>
        </div>
      }

      <!-- Processed Attachments Display -->
      @if (showAttachments) {
        <div class="card mb-4">
          <div class="card-header bg-primary text-white">
            <h5 class="mb-0">
              <mat-icon class="align-middle mr-2">description</mat-icon>
              AI Attachments ({{ processedAttachments.length }})
            </h5>
            <small class="text-white-50">Survey, Question & Answer Attachments - All States</small>
          </div>
          <div class="card-body p-0">
            @if (processedAttachments.length > 0) {
              <div class="table-responsive">
                <table mat-table [dataSource]="processedAttachments" class="w-100 attachments-table" multiTemplateDataRows>
                  <!-- Name Column -->
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef class="font-weight-bold">{{ 'generic.name' | translate }}</th>
                    <td mat-cell *matCellDef="let attachment">
                      <div class="d-flex align-items-center">
                        <mat-icon class="mr-2">{{ attachment.type === 'FILE' ? 'insert_drive_file' : 'article' }}</mat-icon>
                        <div>
                          <a [href]="attachment.link || '#'" target="_blank" rel="noopener noreferrer" [class.disabled]="!attachment.link">
                            {{ attachment.name || attachment.title || 'Attachment' }}
                          </a>
                          <br>
                          @if (attachment.doi) {
                            <small class="text-muted">
                              DOI: <a [href]="'https://doi.org/' + attachment.doi" target="_blank" rel="noopener noreferrer">{{ attachment.doi }}</a>
                            </small>
                          } @else {
                            <small class="text-warning">No DOI</small>
                          }
                        </div>
                      </div>
                    </td>
                  </ng-container>

                  <!-- Type Column -->
                  <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef class="font-weight-bold">{{ 'generic.type' | translate }}</th>
                    <td mat-cell *matCellDef="let attachment">
                      <span class="badge badge-secondary">{{ attachment.type }}</span>
                    </td>
                  </ng-container>

                  <!-- Level Column -->
                  <ng-container matColumnDef="level">
                    <th mat-header-cell *matHeaderCellDef class="font-weight-bold">Level</th>
                    <td mat-cell *matCellDef="let attachment">
                      <span class="badge badge-info">{{ attachment.level || 'N/A' }}</span>
                    </td>
                  </ng-container>

                  <!-- Status Column -->
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class="font-weight-bold">Status</th>
                    <td mat-cell *matCellDef="let attachment">
                      <span [ngClass]="{
                        'badge': true,
                        'badge-success': attachment.state === 'completed',
                        'badge-warning': attachment.state === 'processing' || attachment.state === 'waiting',
                        'badge-danger': attachment.state === 'failed'
                      }">
                        <mat-icon class="badge-icon" *ngIf="attachment.state === 'processing'">autorenew</mat-icon>
                        <mat-icon class="badge-icon" *ngIf="attachment.state === 'waiting'">schedule</mat-icon>
                        {{ attachment.state }}
                      </span>
                    </td>
                  </ng-container>

                  <!-- Date Column -->
                  <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef class="font-weight-bold">{{ 'generic.date' | translate }}</th>
                    <td mat-cell *matCellDef="let attachment">
                      <small>{{ (attachment.updated_at || attachment.created_at) | date:'short' }}</small>
                    </td>
                  </ng-container>

                  <!-- Analysis Column -->
                  <ng-container matColumnDef="analysis">
                    <th mat-header-cell *matHeaderCellDef class="font-weight-bold">Analysis</th>
                    <td mat-cell *matCellDef="let attachment">
                      @if (attachment.state === 'failed' && attachment.llm_analysis) {
                        <button
                          mat-icon-button
                          color="warn"
                          (click)="toggleAnalysisExpansion(attachment.id)"
                          matTooltip="View Error Details">
                          <mat-icon>error_outline</mat-icon>
                        </button>
                      } @else if (attachment.analysis || attachment.result || attachment.llm_analysis) {
                        <button
                          mat-icon-button
                          color="primary"
                          (click)="toggleAnalysisExpansion(attachment.id)"
                          matTooltip="View Details">
                          <mat-icon>{{ expandedAttachmentId === attachment.id ? 'expand_less' : 'expand_more' }}</mat-icon>
                        </button>
                      } @else {
                        <span class="text-muted">-</span>
                      }
                    </td>
                  </ng-container>

                  <!-- Expanded Detail Row -->
                  <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let attachment" [attr.colspan]="displayedColumns.length">
                      @if (expandedAttachmentId === attachment.id && (attachment.analysis || attachment.result || attachment.llm_analysis)) {
                        <div class="attachment-detail-expanded p-3">
                          @if (attachment.state === 'failed' && attachment.llm_analysis) {
                            <div class="alert alert-danger mb-2">
                              <strong>Error:</strong> Processing failed
                            </div>
                          }
                          <div class="analysis-content">
                            <markdown [data]="attachment.analysis || attachment.result || attachment.llm_analysis"></markdown>
                          </div>
                        </div>
                      }
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
                </table>
              </div>
            } @else {
              <div class="p-4">
                <p class="text-muted text-center mb-0">No processed attachments found.</p>
              </div>
            }
          </div>
        </div>
      }

      <!-- Pulsante per generare/mostrare analisi -->
      @if (shouldShowButton) {
        <div class="text-center mb-3">
          <button
            mat-raised-button
            color="accent"
            (click)="onGenerateAiAnalysisClick()"
            >
            {{ 'modal.modal-ai-analysis.title' | translate }}
          </button>
        </div>
      }

      <!-- Indicatore di caricamento -->
      @if (loading) {
        <div class="d-flex flex-column align-items-center">
          <mat-spinner diameter="40"></mat-spinner>
          <!-- <p class="mt-3 text-muted">
            {{ 'generic.ai-analysis-in-progress' | translate }}
          </p> -->
          <!-- @if (isPolling) {
            <p class="text-muted small">
              {{ "attempt" | translate }}: {{ pollingAttempts }} / {{ maxPollingAttempts }}
            </p>
          } -->
        </div>
      }

      <!-- Errore -->
      @if (analysisError && !loading) {
        <div class="alert alert-danger" role="alert">
          <mat-icon>error</mat-icon>
          {{ 'AI Analysis Error - timeout' | translate }}
        </div>
      }

      <!-- Analisi completate -->
      @if (!loading && !analysisError && aiAnalyses?.analyses && areAnalysesComplete()) {
        <!-- Data ultima elaborazione -->
        @if (lastAnalysisDate) {
          <div class="mb-3">
            <small class="text-muted">
              <strong>{{ 'analysis date' | translate }}:</strong>
              {{ lastAnalysisDate | date:'dd/MM/yyyy HH:mm' }}
            </small>
          </div>
        }

        <!-- Select per tipo di analisi -->
        <div class="mb-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'analysis type' | translate }}</mat-label>
            <mat-select [(value)]="selectedAnalysisType" (selectionChange)="onAnalysisTypeChange($event.value)">
              <mat-option value="super-short">
                {{ 'super-short-analysis' | translate }}
              </mat-option>
              <mat-option value="short">
                {{ 'short-analysis' | translate }}
              </mat-option>
              <mat-option value="full">
                {{ 'full-analysis' | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Pulsante copia -->
        <div class="mb-3">
          <button mat-raised-button color="primary"
            class="action-button"
            (click)="copyText(currentAnalysis)"
            >
            {{ 'generic.copy-text' | translate }}
          </button>
        </div>

        <!-- Riquadro analisi -->
        <div class="ai-text-container">
          <markdown [data]="currentAnalysis"></markdown>
        </div>
      }
    </div>
  </div>
}
